// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"5c7f53fa","703":"a2d8b792"}[chunkId] + ".chunk.js";
};